import { format, parseISO } from 'date-fns'

export default function formatDateTime(dateString: string): string {
  const parsedDate = parseISO(dateString)
  const formattedDate = format(parsedDate, 'dd MMM yyyy, HH:mm')
  return formattedDate
}
